<h3 class="text-white mt-4">Registration Complete!</h3>
